import { Link } from 'react-router-dom';

export default function SistemasGestion() {
  const features = [
    {
      icon: 'ri-file-shield-line',
      title: 'ISO 45001',
      description: 'Sistemas de gestión de seguridad y salud ocupacional.'
    },
    {
      icon: 'ri-leaf-line',
      title: 'ISO 14001',
      description: 'Sistemas de gestión ambiental para operaciones sostenibles.'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Actualización de Sistemas',
      description: 'Mejora continua de sistemas existentes según nuevas normativas.'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Mejora Continua',
      description: 'Optimización de procesos y elevación de estándares HSE.'
    }
  ];

  return (
    <section id="sistemas-gestion" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              Sistemas ISO
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Sistemas de <span className="text-teal-600">Gestión (ISO)</span>
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Implementamos, actualizamos y mejoramos sistemas basados en ISO 45001 y 14001.
            </p>
            <p className="text-base text-gray-600 mb-8 leading-relaxed">
              Desarrollamos e implementamos sistemas de gestión integrados que cumplen con estándares internacionales. Si ya cuentas con un sistema, lo actualizamos y mejoramos para mantenerlo vigente y efectivo. Nuestro enfoque es práctico: sistemas que realmente funcionen en tu operación.
            </p>
            <Link
              to="/contacto"
              className="bg-teal-600 text-white px-8 py-3.5 rounded-lg text-base font-semibold hover:bg-teal-700 transition-colors inline-flex items-center gap-2 whitespace-nowrap shadow-lg hover:shadow-xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-500"
            >
              Cotiza tu sistema de gestión
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              
<img
  src="/images/services/implementacion-sistemas-gestion.webp"
  alt="Implementación de Sistemas de Gestión"
  width={900}
  height={830}
  loading="lazy"
  decoding="async"
  className="w-full h-full object-cover object-center"
/>

            </div>
            <div className="absolute -bottom-8 -right-8 bg-white rounded-xl p-6 shadow-xl border border-gray-100 max-w-xs">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center">
                  <i className="ri-award-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900">ISO</div>
                  <div className="text-sm text-gray-600">Estándares Internacionales</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-xl p-6 hover:bg-white hover:shadow-lg transition-all border border-gray-100"
            >
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className={`${feature.icon} text-2xl text-teal-600`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}